import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'maintenanceSummary',
  templateUrl: './maintenanceSummary.component.html',  
})

 export class maintenanceSummaryComponent {
 public prjId:any
 public userId:any
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit(){ 
  }

}
 


// WEBPACK FOOTER //
// ./src/app/maintenance/maintenanceSummary/maintenanceSummary.component.ts